var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.417,
    height: 27,
    viewBox: "0 0 18.417 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-11.22 -3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sicurezza",
    transform: "translate(12.22 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_134",
    "data-name": "Tracciato 134",
    d: "M23.468,4.5h.344a4.033,4.033,0,0,1,4.033,4.033v4.55H19.44V8.533A4.033,4.033,0,0,1,23.468,4.5Z",
    transform: "translate(-15.429 -4.5)",
    fill: "none",
    stroke: "#e9e9e9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_103",
    "data-name": "Rettangolo 103",
    width: 16.417,
    height: 16.417,
    rx: 2.27,
    transform: "translate(0 8.583)",
    fill: "none",
    stroke: "#e9e9e9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_33",
    "data-name": "Ellisse 33",
    cx: 2.489,
    cy: 2.489,
    r: 2.489,
    transform: "translate(5.722 13.011)",
    fill: "none",
    stroke: "#e9e9e9",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_122",
    "data-name": "Linea 122",
    y2: 2.578,
    transform: "translate(8.211 17.989)",
    fill: "none",
    stroke: "#e9e9e9",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputLockIcon);
export default __webpack_public_path__ + "static/media/input-lock-icon.c18c5fb09fb77532fd3412af739d428e.svg";
export { ForwardRef as ReactComponent };